import gql from 'graphql-tag';

export const createCheckoutSession = gql`
  mutation CheckoutSession($input: CreateCheckoutSession!) {
    createCheckoutSession(input: $input) {
      sessionId
    }
  }
`;

export const createPortalSession = gql`
  mutation PortalSession($input: CreatePortalSession!) {
    createPortalSession(input: $input) {
      portalSessionUrl
    }
  }
`;
